module.exports = __webpack_public_path__ + "img/marker.f43ab8c7.png";